import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import Icon from "../custom/Icon";
import { Button } from "../ui/button";

export default function SessionExpired() {
	const { t } = useTranslation();

	return (
		<div className="p-8 border rounded-large bg-gradient-main min-h-screen flex items-center justify-center flex-col">
			<Icon name="LeafyGreen" className="w-16 h-16 mb-4" />
			<p className="text-2xl font-semibold mb-4">
				{t("session.expired_message")}
			</p>
			<Button asChild className="" variant="primary">
				<Link to="/auth/signin">{t("session.sign_in")}</Link>
			</Button>
		</div>
	);
}
